import { Text, View } from 'react-native'

const CustomListView = ({ RenderItems, data }) => (
  <View style={{ width: '100%' }}>
    <RenderItems />
  </View>
)

export default CustomListView
